import React from "react";

type CateringIconProps = {
  color?: string;
};

/** Fork + knife — marks the Catering experience entry in the nav menus. */
const CateringIcon: React.FC<
  CateringIconProps & React.SVGProps<SVGSVGElement>
> = ({ color = "#000", ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 2v7a2.5 2.5 0 0 0 2 2.45V22a1 1 0 0 0 2 0V11.45A2.5 2.5 0 0 0 13 9V2a1 1 0 0 0-2 0v6a.5.5 0 0 1-1 0V2a1 1 0 0 0-2 0v6a.5.5 0 0 1-1 0V2a1 1 0 0 0-2 0Z"
        fill={color}
      />
      <path
        d="M18 2c-1.7 0-3 2.2-3 5 0 2.4 1 4.4 2.3 4.9V22a1 1 0 0 0 2 0V2.9A1 1 0 0 0 18 2Z"
        fill={color}
      />
    </svg>
  );
};

export default CateringIcon;
